import { useEffect, useState } from 'react';
import { IFulfilmentResponse } from '../../interfaces/FulfilmentInterfaces';
import { IPharmacyList } from '../../interfaces/PharmacyInterface';
import ConfirmationModal from '../common/ConfirmationModal';
import { addToast } from '../../utils/toastNotifications';
import { endpoints } from '../../utils/URLs';
import axios from 'axios';

const FulfilmentSideModal = ({
  showModal,
  modalData,
  close,
}: {
  showModal: boolean;
  modalData: IFulfilmentResponse | undefined;
  close: Function;
}) => {
  const [pharmacyInfo, setPharmacyInfo] = useState({
    pharmacyName: '',
    pharmacyAddress: '....',
  });

  const [confimation, setConfirmation] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const [modalText, setModalText] = useState('Are you sure you want to re-profile this request?');

  useEffect(() => {
    //get pharmacy info

    if (showModal) {
      const savedPharmacyList = sessionStorage.getItem('pharmacy-list');

      if (!savedPharmacyList || savedPharmacyList === null) {
        return;
      }

      const parsedList = JSON.parse(savedPharmacyList) as IPharmacyList[];
      const selectedPharmacy = parsedList.filter((x) => x.pharmacyCode === modalData?.pharmacyCode);
      if (selectedPharmacy.length === 0) {
        return;
      }
      const found = selectedPharmacy[0];
      setPharmacyInfo((f) => {
        return {
          ...f,
          pharmacyAddress: found.address,
          pharmacyName: found.pharmacyName,
        };
      });
    }
  }, [modalData, showModal]);

  const formatFulfilmentStatus = (fulfilmentStatus: string) => {
    switch (fulfilmentStatus) {
      case 'Dispensed':
      case 'Processing':
      case 'InReview':
        return 'Processing';
      case 'Approved':
        return 'Ready';
      case 'Completed':
        return 'Picked up / Delivered';
      default:
        return fulfilmentStatus;
    }
  };

  const getStatusColor = (fulfilmentStatus: string) => {
    switch (fulfilmentStatus) {
      case 'Approved':
      case 'Completed':
        return 'btn-success';
      case 'Cancelled':
        return 'btn-danger';
      default:
        return 'btn-info';
    }
  };

  const handleReprofile = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    const text = `Are you sure you want to re-profile the fulfilment for ${modalData?.enrolleeFirstName} ${modalData?.enrolleeLastName} (${modalData?.enrollmentCode}). 
    This will be done as a new fulfilment`;
    setModalText(text);
    setConfirmation(true);
    //oprn confimation modal
  };

  const reprofileFulfilment = async () => {
    const payload = {
      requestId: modalData?.requestId,
      refId: '',
      refPickupCode: '',
    };
    const url = `${endpoints.fulfilments.mainUrl}/reprofile`;

    try {
      await axios.post(url, payload);
      addToast('The fulfilment successfully reprofiled', 'success');
      setConfirmation(false);
      setShowBtn(false);
    } catch (error) {
      addToast('An error occured when reprofiling', 'error');
    }
  };

  return (
    <div
      id='sidebarMenu'
      className={
        showModal
          ? 'col-md-6 col-lg-4 right-sidebar sideshow'
          : 'col-md-6 col-lg-4 right-sidebar sidehide'
      }
    >
      <ConfirmationModal
        title='Re-profile fulfilment'
        show={confimation}
        okCallback={reprofileFulfilment}
        content={modalText}
        hide={() => setConfirmation(false)}
        cancelText='Cancel'
        cancelCallback={() => setConfirmation(false)}
      />

      <div className='right-sidebar-sticky pt-3 mt-2 bg-green-light'>
        <div className='float-right'>
          <span
            className='btn btn-sm fs-7 text-danger'
            style={{ marginLeft: '-10px' }}
            onClick={() => close('Info')}
          >
            Close (x)
          </span>
        </div>
        <div className='mt-5' style={{ clear: 'both' }}>
          {modalData && (
            <div>
              <h5 className='text-center mt-2 fw-bold '>
                {modalData.enrolleeFirstName} {modalData.enrolleeLastName} (
                {modalData.enrollmentCode})
              </h5>
              <div className='mt-3 d-flex align-items-middle justify-content-between'>
                <div>
                  <span className='btn-secondary p-1 btn-sm'>{modalData.fulfilmentService}</span>
                  <span
                    className={
                      'ml-3 btn-success p-1 btn-sm ' + getStatusColor(modalData.fulfilmentStatus)
                    }
                  >
                    {formatFulfilmentStatus(modalData.fulfilmentStatus)}
                  </span>
                </div>
                {modalData.fulfilmentStatus === 'Cancelled' && showBtn && (
                  <button className='btn btn-primary btn-sm float-right' onClick={handleReprofile}>
                    Re-profile
                  </button>
                )}
              </div>
              <div className='mt-4'>
                <label className='fs-7 fw-light'>Phone number</label>
                <div className=''>{modalData.enrolleePhone}</div>
              </div>
              <div className='mt-4'>
                <label className='fs-7 fw-light'>Address</label>
                <div className=''>{modalData.enrolleeAddress}</div>
              </div>
              <div className='mt-4'>
                <label className='fs-7 fw-light'>Pharmacy</label>
                <div className='fw-bold'>{pharmacyInfo.pharmacyName}</div>
                <div className='mt-2'>{pharmacyInfo.pharmacyAddress}</div>
              </div>

              <div className='mt-4'>
                <label className='fs-7 fw-light'>Medications Dispensed</label>
                <table className='table table-borderless custom-table'>
                  <tbody>
                    {modalData.drugs.map((drug) => (
                      <tr className='custom-tr mt-3'>
                        <td>
                          {drug.split('\r\n').map((x) => (
                            <div className='mt-1'>{x}</div>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FulfilmentSideModal;
